import React from 'react';
import './Skeleton.css';

interface SkeletonProps {
    /** CSS width, e.g. '40%' or '120px'. Default: full width. */
    width?: string;
    /** CSS height. Default: one line of text. */
    height?: string;
    className?: string;
    /** Render inline (a word inside text) instead of a block. */
    inline?: boolean;
}

/**
 * A pulsing grey box standing in for content that is still loading, so the
 * finished layout appears in place instead of jumping in after a spinner.
 * Lay skeletons out with the same classes as the real elements so nothing
 * shifts when the data lands.
 */
const Skeleton: React.FC<SkeletonProps> = ({ width, height, className = '', inline = false }) => (
    <span
        className={`skeleton ${inline ? 'skeleton-inline' : 'skeleton-block'} ${className}`}
        style={{ width, height }}
        aria-hidden="true"
    />
);

export default Skeleton;
